import { AppProviders } from '@/providers/AppProviders';
import { Router } from '@/router/Router';

const App = () => (
    <AppProviders>
        <Router />
    </AppProviders>
);

export default App;
